define([
    "dojo/_base/declare",
    "csi/def/Action",
    "csi/xml"
], function(declare,Action,xml) {

    return declare(Action,  {

        validate: function(/*Context*/ctx) {
            var node = ctx.getNode();
            var nodeState = xml.enumGetText(node.State);
            switch (nodeState) {
                case "Draft": return false;
                case "Pending": return false;
                case "Approved": return true;
                default: return true;
            }
        }
    });
});